module.exports = __webpack_public_path__ + "Roboto-LightItalic.1a9e39e536aed26b863b.svg";


//////////////////
// WEBPACK FOOTER
// /jenkins/jenkins/workspace/apppronosticos_install_s3_dev/~/roboto-fontface/fonts/Roboto/Roboto-LightItalic.svg
// module id = ../../../../roboto-fontface/fonts/Roboto/Roboto-LightItalic.svg
// module chunks = 5